/*
    Catalog of Schoolhouse assessment products offered to users.
    When a new assessment ships, add it here; the registration form's
    product list is derived from this list.

    Each entry is the exact label shown on the registration form and saved
    in the user's `product` field, so don't reword existing entries.
*/
const assessments = [
  'Assessment of Nonverbal Contextual Reasoning (ANCR)',
  "Children's Psychological Processes Scale (CPPS) Parent",
  "Children's Psychological Processes Scale, Normative Update (CPPS NU) Teacher",
  'Haak-2',
  'McCloskey Executive Functions Scale (MEFS) Parent',
  'McCloskey Executive Functions Scale (MEFS) Teacher',
  'McCloskey Social-Emotional Learning Scale (MSELS)',
  'McCloskey Social-Emotional Learning Scale (MSELS) Parent',
  'McCloskey Social-Emotional Learning Scale (MSELS) Teacher',
  'Reynolds Dyslexia Risk Assessment (RDRA)',
  'Student Anxiety Rating Scale (STARS)',
  'Woodcock-Camarata Articulation Test (WCAT)'
];

export default assessments;
